import React, { useState, useEffect } from "react";
import styles from "./TemplateHero28.module.css";

const TemplateHero28 = ({ branding, heroData }) => {
  const [current, setCurrent] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const slides = heroData?.slides || [];

  const goTo = (index) => {
    if (isAnimating || index === current) return;

    setIsAnimating(true);

    setTimeout(() => {
      setCurrent(index);
      setIsAnimating(false);
    }, 450);
  };

  useEffect(() => {
    if (slides.length <= 1) return;

    const t = setInterval(() => {
      goTo((current + 1) % slides.length);
    }, 5500);

    return () => clearInterval(t);
  }, [current, slides.length, isAnimating]);

  if (!slides.length) return null;

  const perfCount = 40;

  return (
    <div className={styles.root}>
      <div className={styles.glow} />

      {/* Top bar */}
      <div className={styles.topbar}>
        <span className={styles.brand}>
          {branding?.companyName || "Travel Films"}
        </span>

        <span className={styles.reelId}>
          REEL #{String(current + 1).padStart(3, "0")} · {slides.length} SCENES
        </span>
      </div>

      {/* Film strip */}
      <div className={styles.filmWrap}>

        {/* Top perforations */}
        <div className={styles.perfs}>
          {Array.from({ length: perfCount }).map((_, i) => (
            <div key={i} className={styles.perfHole} />
          ))}
        </div>

        {/* Frames */}
        <div
          className={styles.strip}
          style={{
            transform: `translateX(calc(-${current} * (56vw + 8px) + 22vw))`,
          }}
        >
          {slides.map((s, i) => (
            <div
              key={i}
              className={`${styles.frame} ${
                i === current ? styles.activeFrame : ""
              }`}
              onClick={() => goTo(i)}
            >
              <div
                className={styles.frameImg}
                style={{ backgroundImage: `url('${s.image}')` }}
              />

              <div className={styles.frameNum}>
                FRAME {String(i + 1).padStart(2, "0")}
              </div>

              <div className={styles.frameContent}>
                <h2 className={styles.frameTitle}>{s.title}</h2>

                <p className={styles.frameSub}>
                  {s.subtitle?.substring(0, 60)}...
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom perforations */}
        <div className={styles.perfs}>
          {Array.from({ length: perfCount }).map((_, i) => (
            <div key={i} className={styles.perfHole} />
          ))}
        </div>
      </div>

      {/* Bottom controls */}
      <div className={styles.bottom}>
        <div className={styles.slideInfo}>

          <div className={styles.navBtns}>
            <button
              className={styles.navBtn}
              onClick={() =>
                goTo((current - 1 + slides.length) % slides.length)
              }
            >
              ◀
            </button>

            <button
              className={styles.navBtn}
              onClick={() =>
                goTo((current + 1) % slides.length)
              }
            >
              ▶
            </button>
          </div>

          <span className={styles.counter}>
            {String(current + 1).padStart(2, "0")} /{" "}
            {String(slides.length).padStart(2, "0")}
          </span>

          <div className={styles.dots}>
            {slides.map((_, i) => (
              <div
                key={i}
                className={`${styles.dot} ${
                  i === current ? styles.activeDot : ""
                }`}
                onClick={() => goTo(i)}
              />
            ))}
          </div>
        </div>

        <div className={styles.ctaArea}>
          <button className={styles.cta}>Book This Journey</button>

          <button className={styles.ctaGhost}>
            All Packages
          </button>
        </div>
      </div>
    </div>
  );
};

export default TemplateHero28;